// 业务单据类型配置
export default {
  businessType: {
    collapseTitle: {
      businessTitle: '业务单据类型',
      interOperTitle: '计息操作类型',
    },
    businessTable: {
      orderCode: '单据代码',
      orderCodePlaceholder: '请输入单据代码',
      orderName: '单据名称',
      orderNamePlaceholder: '请输入单据名称',
      orderDesc: '单据描述',
      orderDescPlaceholder: '请输入单据描述',
    },
    interOperTable: {
      eventCode: '事件代码',
      eventCodePlaceholder: '请输入事件代码',
      eventName: '事件名称',
      eventNamePlaceholder: '请输入事件名称',
      eventDesc: '事件描述',
      eventDescPlaceholder: '请输入事件描述',
      conditionRule: '事件判定条件',
      conditionRulePlaceholder: '请输入事件判定条件',
    },
    btnList: {
      save: '保存',
    },
    msg: {
      noBusinessType: '请填写业务单据类型',
      noData: '您还未选择任何数据',
      deleteSuccess: '删除成功',
      cancelled: '已取消',
      saveSussess: '保存成功！',
      saveFail: '保存失败！',
    },
  },
};
